export const Section1 = {
	heading: 'Maximize Your Natural Products Expo West Experience with Beacon Discovery!',
	content1: 'It’s January and',
	content2_link: ' Expo West',
	content3: ' will be here before you know it, and if you’re a brand ready to make waves, ',
	content4_link: 'Beacon Discovery',
	content5:
		' is your backstage pass to getting noticed by retailers. But here’s the twist: retailers are already using Beacon Discovery months out from the show to search for brands they want to connect with in March. That means now is the time to get your profile in top shape so you’re on their radar before they even set foot in Anaheim.',
	content6:
		'Here’s how to get your Beacon Discovery profile in tip-top shape and stand out from the crowd:'
};

export const Section2 = {
	heading: 'Give Your Profile a Glow-Up',
	content1:
		'Think of your Beacon Discovery profile like your brand’s resume—it’s the first impression retailers get before they head to the show, so make it stand out! Here’s what to focus on:',
	item1: {
		boldcontent: 'Brand Info: ',
		content:
			'Update your logo, tell your brand’s story (we know you’ve got one!), and make sure all your key details—like your headquarters location—are up to date.'
	},
	item2: {
		boldcontent: 'Contact Info: ',
		content:
			'You want retailers to easily be able to get in touch with you! Make sure your email and phone numbers are updated.'
	},
	item3: {
		boldcontent: 'Social Media & Distribution: ',
		content:
			'Make it easy for retailers to follow you by linking your social media. And don’t forget to update your distribution channels.'
	},
	content2:
		'With this, your Beacon Hub (located within your Beacon Discovery profile) is your BFF—an easy-to-use space to update all your profile info in one spot.',
	content3:
		'You want to make a good first impression and with everything up to date, you’re more likely to attract the right retailers!'
};

export const Section3 = {
	heading: 'Show Off Your Products Like a Pro',
	content1:
		'Expo West is all about products, products, and even more products! Make sure you stand out by:',
	item1: {
		boldcontent: 'Spring Cleaning:',
		content:
			' Remove any products that are no longer available. No one wants to see what’s no longer available!'
	},
	item2: {
		boldcontent: 'New Launches: ',
		content:
			' Got something new? Perfect! Make sure your latest and greatest products are front and center, so retailers know what’s hot.'
	},
	item3: {
		boldcontent: 'Picture-Perfect Product Photos: ',
		content:
			'You know what they say— “A picture is worth a thousand words!” Make sure your product photos are high-quality and look as good as your products do.'
	}
};

export const Section4 = {
	heading: "Don't Forget the MarketReady Verified Badge",
	content1: 'If you’re serious about attracting retailers, applying for a ',
	content2_link: 'MarketReady Verified Badge',
	content3:
		' is a great first step. This badge shows retailers “We’re ready for business!” and adds extra credibility to your brand’s profile.',
	content4: 'Working with the ',
	content5: 'MarketReady Insights',
	content6:
		' team to earn this badge can increase your visibility. When you have this badge on your Beacon Discovery profile, retailers know you’re a serious player in the market, and that can make all the difference. '
};

export const Section5 = {
	heading: "Walk in a Retailer' Shoes",
	content1:
		'Step into the shoes of a retailer who is scoping out brands. Does your profile have everything they need to know?',
	content2:
		'From contact information to a compelling brand story this is where it helps to think like a retailer—what do they need to know to make a decision quickly and confidently? Tailoring your profile to retailers’ needs is crucial for making those connections!'
};

export const Section6 = {
	heading: 'Conclusion',
	content1:
		'Getting your Beacon Discovery profile ready for Expo West is one of the best ways to make sure that your brand stands out to retailers before the show. By keeping your profile updated, showcasing your products, earning that MarketReady Verified badge, and seeing your profile through the eyes of a retailer, you’ll be on your way to building lasting partnerships.',
	content2:
		'Retailers are already using Beacon Discovery to search for brands they want to connect with—let them find you!'
};

export enum Links {
	expo_west = 'https://www.expowest.com/en/home.html',
	beacon_discovery = 'https://beaconapp.newhope.com/',
	market_ready = 'https://marketreadyinsights.com/',
	ayeya = 'https://beaconapp.newhope.com/brand/1709932303_65eb7f0f907e17.93794872'
}

export enum Images {
	update_brand = 'https://s44021.pcdn.co/wp-content/uploads/2025/01/Brand-1.png',
	ayeya = 'https://s44021.pcdn.co/wp-content/uploads/2025/01/1.png',
	ayeya_mid = 'https://s44021.pcdn.co/wp-content/uploads/2025/01/2.png',
	ayeya_back = 'https://s44021.pcdn.co/wp-content/uploads/2025/01/3.png',
	market_ready = 'https://s44021.pcdn.co/wp-content/uploads/2023/05/MarketReady-logo.png'
}
